export const optionsAppFooterRHF = {
  inputsOptions: {
    file: {
      key: "file",
      type: "file",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    appSheetCnt: {
      key: "appSheetCnt",
      label: "Количество листов",
      type: "text",
      placeholder: "Введите",
      fieldModeView: false,
      disabled: false,
      required: false,
      needInForm: true,
    },
    appDate: {
      key: "appDate",
      label: "Дата подачи заявления",
      type: "date",
      fieldModeView: false,
      disabled: false,
      required: true,
      needInForm: true,
      customValidation(value) {
        if (new Date(value) > new Date()) {
          return "Дата не может быть позднее текущей";
        } else if (new Date(value) < new Date("1996-09-26T00:00:00.000+03:00")) {
          return "Дата не может быть ранее 26.09.1996";
        } else {
          return true;
        }
      },
    },
    appUser: {
      key: "appUser",
      label: "Должностное лицо",
      type: "selectWithSearch",
      placeholder: "Выберите",
      fieldModeView: false,
      disabled: true,
      isSearchable: false,
      required: true,
      needInForm: true,
      options: [],
    },
  },
};

export const addAdditionalCustomValidation = (value) => {
  if (value) {
    optionsAppFooterRHF.inputsOptions.appDate.additionalCustomValidation = value;
  } else {
    delete optionsAppFooterRHF.inputsOptions.appDate.additionalCustomValidation;
  }
  return optionsAppFooterRHF.inputsOptions;
};
